import React from 'react';

const OldGlobalStyled = () => {
  return (
    /* copy from globals.scss of old project */
    <style jsx global>{`

      @import 'node_modules/react-modal-video/scss/modal-video.scss';

      @font-face {
        font-family: 'Prometo';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('/fonts/Prometo/Prometo.ttf');
      }
      @font-face {
        font-family: 'Prometo';
        font-style: normal;
        font-weight: 300;
        font-display: swap;
        src: url('/fonts/Prometo/Prometo-Light.ttf');
      }
      @font-face {
        font-family: 'Prometo';
        font-weight: 700;
        src: url('/fonts/Prometo/Prometo-Bold.ttf');
      }

      // @font-face {
      //   font-family: 'Kanit';
      //   font-style: normal;
      //   src: url('/fonts/Kanit/Kanit-Medium.ttf');
      //   unicode-range: U+0E00 — 0e7f;
      // }

      @font-face {
        font-family: 'Kanit';
        font-style: normal;
        font-weight: 500;
        src: url('/fonts/Kanit/Kanit-Medium.ttf');
        unicode-range: U+0E00-0e7f;
      }

      @font-face {
        font-family: 'Kanit';
        font-style: normal;
        font-weight: 300;
        src: url('/fonts/Kanit/Kanit-Light.ttf');
        unicode-range: U+0E00-0e7f;
      }

      @font-face {
        font-family: 'Kanit';
        font-style: normal;
        font-weight: 700;
        src: url('/fonts/Kanit/Kanit-Bold.ttf');
        unicode-range: U+0E00-0e7f;
      }

      @font-face {
        font-family: 'BaiJamjuree';
        font-style: normal;
        font-weight: 500;
        src: url('/fonts/Bai_Jamjuree/BaiJamjuree-Medium.ttf');
        unicode-range: U+0E00-0e7f;
      }

      @font-face {
        font-family: 'BaiJamjuree';
        font-style: normal;
        font-weight: 300;
        src: url('/fonts/Bai_Jamjuree/BaiJamjuree-Light.ttf');
        unicode-range: U+0E00-0e7f;
      }

      @font-face {
        font-family: 'BaiJamjuree';
        font-style: normal;
        font-weight: 700;
        src: url('/fonts/Bai_Jamjuree/BaiJamjuree-Bold.ttf');
        unicode-range: U+0E00-0e7f;
      }

      .kanit {
        font-family: 'Kanit', 'Helvetica', sans-serif;
      }

      .jamjuree {
        font-family: 'BaiJamjuree', 'Helvetica', sans-serif;
      }

      // .prometo {
      //   font-family: 'Prometo', 'Kanit', sans-serif;
      //   color: '#0B273E';
      // }
      .sfpro {
        font-family: 'SfPro', 'Helvetica', sans-serif;
      }

      html {
        font-size: calc(0.2em + 1vw);
      }

      html,
      body {
        width: 100vw;
        overflow-x: hidden;
        padding: 0;
        margin: 0;
        font-family: 'Prometo', 'BaiJamjuree', sans-serif;
        font-weight: normal;
        button:focus {
          outline: none !important;
        }

        .modal-open {
          height: 100vh !important;
          overflow-y: hidden !important;
        }
      }
      p,
      span,
      h1,
      h2,
      h3,
      h4 {
        font-family: 'Prometo', 'BaiJamjuree', sans-serif;
      }

      a {
        color: inherit;
        text-decoration: none;
      }

      * {
        box-sizing: border-box;
      }

      nav {
        font-family: 'Prometo';
      }

      $codium-blue: #0b273e;
      $contact: #29adce;
      $dark-blue: #0d375b;
      $light-gray: #f8f8f8;
      $modalSuccess: #e6f9fc;

      .navbar-icon {
        color: $contact;
      }

      .menu-icon {
        font-size: 16px !important;
      }

      .custom-blue-button {
        background-color: $contact;
        color: white;
        border-radius: 10px;
        filter: brightness(100%);
        transition: filter 0.25s ease;
        font-size: 20px;
        line-height: 20px;
        padding: 15px 30px;
        width: fit-content;
        height: fit-content;

        &:hover {
          filter: brightness(110%);
          transition: filter 0.25s ease;
        }

        @media only screen and (max-width: 425px) {
          font-size: 15px;
          line-height: 15px;
          padding: 12px 24px;
        }
      }

      .mw-70percent {
        max-width: 70%;
      }

      .text-blue {
        color: #0d375b;
      }

      .text-contact {
        color: $contact;
      }

      .text-dark-blue {
        color: $dark-blue;
      }

      .bg-dark-blue {
        background-color: $dark-blue;
      }

      .bg-contact {
        background-color: $contact;
      }

      .bg-light-gray {
        background-color: $light-gray;
      }

      .bg-button-contact {
        background-color: $contact;
      }

      .bg-modal-success {
        background-color: $modalSuccess;
      }

      .border-dark-blue {
        border-color: $dark-blue;
      }

      .text-webkit-center {
        text-align: -webkit-center;
      }

      .footer {
        background-color: $codium-blue;
      }

      .text-red {
        color: #e84847;
      }

      .bottom-10 {
        bottom: 10%;

        @media only screen and (max-width: 1024px) and (orientation: landscape) {
          bottom: -3%;
        }
      }

      .transform-50 {
        transform: translate(-50%, -50%);
      }

      .align-self-center {
        align-self: center;
      }

      .iphone-noti {
        width: 450px;
      }

      .thai-lh {
        line-height: 170% !important;
      }

      .bg-ihpone {
        background: url(/images/homepage/bgIphone.webp);
        background-color: #0b273e;
        width: 100vw;
        min-height: 100vh;
        height: auto;
        background-repeat: no-repeat;
        background-position: center;
      }

      .cookies-content {
        width: 90%;
        margin: 0 5%;
      }

      .noti-bg-color {
        background-color: #1c1c1e;
      }

      .header-image {
        // background-image: url(/images/bg01.png);
        background-repeat: no-repeat;
        background-size: auto 100vh;
        width: auto;
        height: 100vh;
        background-position: center;
        video {
          opacity: 0.6;
        }
        @media only screen and (min-width: 1024px) {
          // background-size: 100vw 48vh !important;
          width: 100vw !important;
          // height: 48vh !important;
        }

        @media only screen and (min-width: 1440px) {
          background-size: 100vw 100vh !important;
          width: 100vw;
          // width: 100vw !important;
        }
      }

      @media only screen and (max-width: 823px) and (orientation: landscape) {
        .header-image {
          background-size: auto 100vh !important;
          height: 100vh !important;
        }

        .bottom-10 {
          bottom: -3%;
        }

        .stat-background {
          background-size: unset !important;
          height: fit-content;
        }

        .margin-over {
          margin-top: 50rem;
        }
      }

      .front-main-header {
        margin-bottom: 0;
        font-size: 25px;
        font-weight: 300;
      }

      .google-map-iframe {
        width: 90%;
        height: 320px;
        margin-top: 40px;
      }

      .intro-space {
        line-height: 2.5rem !important;
      }

      .stat-background {
        background-image: url(/images/Rectangle2x.png);
        background-size: 100vw 100vh;
      }

      .shadow-box {
        box-shadow: 0 10px 10px rgb(54 58 62 / 19%);
      }

      .contact-us-bg {
        background-image: url(/images/bg-contact-us.svg);
      }

      .title-bg {
        background-repeat: no-repeat;
        background-size: 100vw 30vh;
        width: 100vw;
        height: 30vh;

        @media only screen and (min-width: 1025px) {
          background-size: 100vw 70vh !important;
          width: 100vw !important;
          height: 70vh !important;
        }

        @media only screen and (max-width: 823px) and (orientation: landscape) {
          background-size: 100vw 80vh !important;
          height: 80vh !important;
        }
      }

      .feature-image-content {
        background-image: url(/images/Path.svg);
        background-repeat: no-repeat;
        background-size: contain;
      }

      .feature-image-content2 {
        top: -200px;
        background-image: url(/images/bg-email-dash.svg);
        background-repeat: no-repeat;
        background-size: 100vw;
      }

      .align-image {
        align-items: center;
        margin-left: -4rem;

        @media only screen and (max-width: 1023px) {
          margin-left: 0;
        }
      }

      [data-aos='custom-animation-left'] {
        opacity: 0;
        img {
          right: 5rem;
        }
        transform: translate3d(50px, 50px, 0);
        transition-property: transform, opacity;

        &.aos-animate {
          opacity: 1;
          transform: none;
          img {
            right: 0;
          }
        }
      }

      [data-aos='custom-animation-right'] {
        opacity: 0;
        transform: translate3d(-50px, 50px, 0);
        transition-property: transform, opacity;

        &.aos-animate {
          opacity: 1;
          transform: none;
        }
      }

      .hallOffFame {
        padding: 2rem;
        border-left: 2px solid #43b3d1;
        padding-top: 0;
      }

      .dot {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background-color: #fff;
        border: 1px solid #43b3d1;
        position: relative;
        left: 4px;
        .dot2 {
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background-color: #43b3d1;
          position: absolute;
          top: 1px;
          left: 1px;
        }
      }

      .bg-gray {
        background-color: #fafafa;
      }

      .close-button {
        width: 70%;
        justify-content: flex-end;
      }

      .btn-success-blue {
        border-radius: 0.5rem !important;
        background-color: #29adce !important;
        color: white;
        padding: 1rem 5rem;
        font-weight: 500;
        box-shadow: 0 10px 10px rgb(54 58 62 / 19%);
        @media only screen and (min-width: 1025px) {
          padding: 0.4rem 2.5rem;
        }
      }

      .bg-gray-50 {
        background-color: #f8f8f8;
      }

      .border-b-1 {
        border-bottom-width: 1px;
      }

      .text-primary {
        color: #0b273e;
      }
      .text-secondary {
        color: #35adce;
      }
      .text-danger {
        color: #fc2839;
      }

      .text-gray {
        color: #707070;
      }

      .bg-primary {
        background-color: $codium-blue;
      }
      .react-multi-carousel-dot-active button {
        background: #43b3d1;
      }

      .textWhite {
        color: #fff;
      }

      ul {
        list-style-type: disc;
      }

      // .typing {
      //   p,
      //   span {
      //     animation: animated-text 4s steps(29, end) 1s 1 normal both, animated-cursor 600ms steps(29, end) infinite;
      //   }

      //   /* text animation */

      //   @keyframes animated-text {
      //     from {
      //       width: 0%;
      //     }
      //     to {
      //       width: 100%;
      //     }
      //   }
      // }

      .blog {
        .react-multiple-carousel__arrow--right {
          right: 0;
        }

        .react-multiple-carousel__arrow--left {
          left: 0;
        }

        .react-multiple-carousel__arrow {
          background: $contact;
        }

        .react-multiple-carousel__arrow:hover {
          background: #90d4e5;
        }
      }

      .explore {
        .react-multiple-carousel__arrow--right {
          right: 10px;
        }

        .react-multiple-carousel__arrow--left {
          left: 10px;
        }

        .react-multiple-carousel__arrow,
        .react-multiple-carousel__arrow:hover {
          background: none;
          z-index: 20;
        }

        .react-multiple-carousel__arrow::before,
        .react-multiple-carousel__arrow::after {
          color: #fff;
          font-size: 5rem;
        }

        .react-multi-carousel-item--active:not(:first-child) {
          @media only screen and (min-width: 1024px) {
            margin-left: 10px;
          }
        }

        img {
          min-height: 40rem;

          @media only screen and (min-width: 1024px) {
            min-height: 30rem;
          }

          @media only screen and (max-width: 823px) and (orientation: landscape) {
            min-height: 350px;
          }
        }
      }

      body.modal-open {
        overflow: hidden;
      }

      .resources-shadow {
        box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
      }

      .video-work {
        border-radius: 10px !important;
        position: absolute !important;
        left: 5% !important;
        top: 7% !important;
        outline: none !important;
        width: 90% !important;
      }

      .video-work2 {
        position: absolute;
        left: 6%;
        top: 4%;
        outline: none;
        width: 88%;
      }

      .increase {
        font-size: 2.75rem;

        @media only screen and (min-width: 640px) {
          font-size: 2.2rem;
        }

        @media only screen and (min-width: 1024px) {
          font-size: 1.35rem;
        }
      }

      .leading {
        line-height: 3.75rem !important;

        @media only screen and (min-width: 640px) {
          line-height: 3.25rem !important;
        }

        @media only screen and (min-width: 1024px) {
          line-height: 2.25rem !important;
        }

        @media only screen and (min-width: 1280px) {
          line-height: 2rem !important;
        }
      }

      .leading-2 {
        line-height: 3.5rem !important;

        @media only screen and (min-width: 640px) {
          line-height: 2.75rem !important;
        }

        @media only screen and (min-width: 1024px) {
          line-height: 1.75rem !important;
        }
      }

      .leading-3 {
        line-height: 4rem !important;

        @media only screen and (min-width: 640px) {
          line-height: 2.5rem !important;
        }

        @media only screen and (min-width: 1024px) {
          line-height: 2rem !important;
        }
      }

      .custom-icon {
        @media only screen and (min-width: 1536px) {
          width: 64px !important;
          height: 64px !important;
        }
      }

      .indent {
        text-indent: 45px;
      }

      ul.inside {
        li {
          margin-left: 45px;
        }
      }

      .min-h-signature {
        min-height: 20rem;
      }

      .mw-500 {
        min-width: 500px;
      }

      .price-border {
        border: 1px solid #0d375b;
        border-radius: 15px;

        @media only screen and (min-width: 768px) {
          border: none;
        }
      }

      .arrow {
        position: relative;
        color: #0d375b;

        .right-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0.5em;

          @media only screen and (min-width: 640px) {
            display: none;
          }
        }

        .left-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0.5em;

          @media only screen and (min-width: 640px) {
            display: none;
          }
        }
      }

      .h-40 {
        height: 40vh;

        @media only screen and (max-width: 823px) and (orientation: landscape) {
          height: 400px;
        }

        @media only screen and (min-width: 1024px) {
          height: auto;
        }
      }

      .absolute-center {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .modal-video-movie-wrap {
        max-width: 90vw;
        margin: auto;
        border-radius: 10px;
      }

      .modal-video-close-btn {
        right: 0;
      }

      .wrap-anywhere {
        overflow-wrap: anywhere;
      }

      .blog-banner {
        height: 35vh;

        @media only screen and (min-width: 361px) {
          height: 35vh;
        }

        @media only screen and (min-width: 768px) {
          height: 40vh;
        }

        @media only screen and (min-width: 1024px) {
          height: 35vh;
        }

        @media only screen and (min-width: 1280px) {
          height: 55vh;
        }

        @media only screen and (orientation: landscape) {
          height: 75vh;
        }

        @media only screen and (min-width: 1024px) and (orientation: landscape) {
          height: 50vh;
        }
      }

      .video-absolute {
        top: 50%;
        transform: translate(0%, -50%);
      }

      .trans-bg {
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 0 0 1rem 1rem;
      }
    `}</style>
  );
};

export default OldGlobalStyled;
